module.exports = __webpack_public_path__ + "img/d.9ca58f2f.jpg";